import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function DottedLineIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="4 4 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="6" r="2" />
        <circle cx="12" cy="12" r="3" />
        <circle cx="12" cy="18" r="2" />
        <rect x="11" y="6" width="2" height="12" />
      </svg>
    </Icon>
  );
}
